import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox } from 'semantic-ui-react';
import { fetchMailingLists } from '../../reducers/mailing_lists';

const MailingListsWidget = ({ value, id, onChange }) => {
  const dispatch = useDispatch();
  const { available, loading, error } = useSelector(
    (state: any) => state.mailingLists,
  );

  // TRANSLATE INCOMING DATA (String -> Array)
  // The backend sends a string (e.g., '["List1", "List2"]'), but we need an array to render the UI.
  const subscribedList = React.useMemo(() => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    if (typeof value === 'string') {
      return JSON.parse(value);
    }
    return [];
  }, [value]);

  useEffect(() => {
    dispatch(fetchMailingLists());
  }, [dispatch]);

  // TRANSLATE OUTGOING DATA (Array -> String)
  // We work with an array locally, but we must join it back into a string
  // before sending it to the form
  const handleToggle = (listName: string, checked: boolean) => {
    const newList = checked
      ? [...subscribedList, listName]
      : subscribedList.filter((name) => name !== listName);
    onChange(id, JSON.stringify(newList));
  };

  if (loading) return <div>Loading mailing lists...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <ul className="mailing-lists no-bullets">
        {available.map((list: string) => (
          <li key={list} className="mailing-list-item">
            <Checkbox
              label={list.replace(/_/g, ' ')}
              checked={subscribedList.includes(list)}
              onChange={(e, { checked }) => handleToggle(list, checked)}
            />
          </li>
        ))}
      </ul>
      <p className="mailing-lists-helper subscription-help-text">
        Save your profile to confirm any changes.
      </p>
    </>
  );
};

export default MailingListsWidget;
